define('lib/vp.jquery.excerpt',['jquery'], function($){

/*!
 * jQuery Excerpt Toggler
 * Original author: Darek Rossman
 */

(function () {

    var pluginName = 'excerpt',
        defaults = {
            characterLimit: 250,
            moreText: 'More',
            lessText: 'Less',
            elWrapper: '<p>',
            $toggleEl: $('<a data-dtm="excerpt" data-toggle="excerpt" href="">')
        };

    // The actual plugin constructor
    function Plugin( element, options ) {
        this.element = element;
        this.$element = $(element);
        this.options = $.extend( {}, defaults, options) ;
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    Plugin.prototype.getCharacterExcerpt = function() {
      var excerptDataAttrs = this.$element.data('excerpt').split(',');
      var self = this,
          content = this.$element.text().trim(),
          excerptLength = excerptDataAttrs[0],
          charIndex,
          excerpt,
          $excerpt,
          $moreLink;

      // create index counter from supplied character limit
      charIndex = (excerptLength != "") ? excerptLength : this.options.characterLimit;

      // find a break in the content so that the
      // excerpt doesn't split a word in the middle
      if (content.length > charIndex) {

        function findSpace( index ) {
          var c = content.charAt( index);
          var pattern = /\w/;
          var match = pattern.test( c );

          if (match) {
            return findSpace(--charIndex);
          } else {

            // get substring of content, append ellipses and 'more' toggle
            var ellipses = '...';
            if (content.substr(0, charIndex) == 0) {
              ellipses = '';
            }
            excerpt = content.substr(0, charIndex) + ellipses;
            $excerpt = $(self.options.elWrapper).text( excerpt );
            $moreLink = self.options.$toggleEl.clone().text(self.options.moreText);
            $excerpt.append($moreLink);

            // return the content as an HTML string
            return $excerpt.wrap('<div/>').parent().html();
          }
        }

        return findSpace(charIndex);

      } else {
        return content;
      }
    };

    Plugin.prototype.toggleExcerpt = function() {
      if (!this.$element.data('excerpt-expanded')) {
        this.expandExcerpt();
      } else {
        this.collapseExcerpt();
      }
    };

    Plugin.prototype.expandExcerpt = function() {
      this.$element
          .html(this.originalHTMLContent)
          .data('excerpt-expanded', true);
    };


    Plugin.prototype.collapseExcerpt = function() {
      this.$element
          .html(this.replacementHTMLContent)
          .data('excerpt-expanded', false);
    };

    Plugin.prototype.init = function () {

      var self = this;
      var excerptDataAttrs = this.$element.data('excerpt').split(',');

      // do not init if body text is not long enough
      if (this.$element.text().length <= excerptDataAttrs[0]) return;

      if (excerptDataAttrs.length > 1) {
        this.options.moreText = excerptDataAttrs[1];
      }

      if (excerptDataAttrs.length > 2) {
        this.options.lessText = excerptDataAttrs[2];
      }


      // create 'less' toggle
      var $lessLink = this.options.$toggleEl.clone().text(' ' + this.options.lessText);

      // append 'less' toggle to last element of original content
      if (this.$element.children().length > 0) {
        this.$element.children().last().append($lessLink);
      } else {
        this.$element.append($lessLink);
      }

      // cache original content as HTML string
      this.originalHTMLContent = this.$element.html();

      // cache excerpt content as HTML string
      this.replacementHTMLContent = this.getCharacterExcerpt();

      // replace the original content with excerpt
      this.collapseExcerpt();

      this.$element.on('click', '[data-toggle="excerpt"]', function (ev) {
        ev.preventDefault();
        self.toggleExcerpt();
      });
    };

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                new Plugin( this, options ));
            }
        });
    }

})();









});

